'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = diffusionProviderFactory;

var _diffusion = require('diffusion');

var _diffusion2 = _interopRequireDefault(_diffusion);

var _subscription = require('../utils/subscription');

var _subscription2 = _interopRequireDefault(_subscription);

var _binaryParser = require('./binaryParser');

var _binaryParser2 = _interopRequireDefault(_binaryParser);

var _domConfigurationStrategy = require('./domConfigurationStrategy');

var _domConfigurationStrategy2 = _interopRequireDefault(_domConfigurationStrategy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function sessionWrapper(session) {
    return {
        stream: function stream(topic) {
            var diffusionSubscription = session.stream(topic).transform(_binaryParser2.default);
            var subscr = (0, _subscription2.default)();
            subscr.subscribe(diffusionSubscription);
            return subscr;
        },
        subscribe: session.subscribe,
        unsubscribe: session.unsubscribe,
        on: session.on,
        off: session.off,
        close: session.close
    };
}

function diffusionProviderFactory() {
    function provider() {
        var configurationStrategy = (0, _domConfigurationStrategy2.default)();
        return _diffusion2.default.connect(configurationStrategy.getConfig()).then(sessionWrapper);
    }
    return {
        provider: provider,
        log: function log(level) {
            return _diffusion2.default.log(level);
        }
    };
}


//////////////////
// WEBPACK FOOTER
// ./~/rp-diffusion-connector/lib/providers/diffusion.js
// module id = 1496
// module chunks = 1